import { TFunction } from 'i18next';

export enum AccountTypeEnum {
  personal = 'personal',
  business = 'business',
}

export const accountTypeOptions = (t: TFunction) => {
  return [
    {
      label: t('signup.accountType.business'),
      value: AccountTypeEnum.business,
    },
    {
      label: t('signup.accountType.personal'),
      value: AccountTypeEnum.personal,
    },
  ];
};
